let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kDPsc"), load("hC295")]).then(() => parcelRequire('ex5uU'));